import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { FormularioCalificacion } from "../../components/EtapasDeCalificacion/FormularioCalificacion";
import { InformacionFuncionario } from "../../components/EtapasDeCalificacion/InformacionFuncionario";
import {
  ambiente_produccion,
  produccion,
  validarEvaluacion,
} from "../../utils/Datos";
import { Dimmer, Loader, Image, Segment } from "semantic-ui-react";

//Para sacar el rut
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";

export const ValidarPorFuncionario = () => {
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const { id_participant, id_precalifiacion } = useParams();
  const [acuerdo, setAcuerdo] = useState(null);
  const [acepto, setAcepto] = useState(null);
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const [cuValida, setcuValida] = useState(null);
  const [cuAbierta, setcuAbierta] = useState(false);

  useEffect(() => {
    if (cuValida != null) {
      if (cuValida) {
        validarEvaluacion({
          id_preQualifications: id_precalifiacion,
          statementOfFunMeeting: acepto,
          isThisAgreement: acuerdo,
        }).then((respuesta) => {
          if (respuesta.status) {
            Swal.fire({
              title: "Autorizado",
              text: "Evaluación validada con éxito",
              icon: "success",
              confirmButtonText: "Ok",
            }).then(function () {
              navigate("/misEvaluaciones");
            });
            //Redirect ?
          } else {
            Swal.fire({
              title: "No autorizado",
              text: respuesta.errores ?? "Ocurrió un error",
              icon: "error",
              confirmButtonText: "Ok",
            }).then(function () {
              setcuAbierta(false);
              setcuValida(null);
            });
          }
          setCargandoDatos(false);
        });
        /*
        Swal.fire({
          icon:'success',
          title:'Autorizado',
          text:'Evaluación validada con éxito'
        }).then(function () {
          navigate("/misEvaluaciones");
        });*/
      }

      if (!cuValida) {
        Swal.fire({
          icon: "error",
          title:
            "La clave única no corresponde al rut del usuario que ha iniciado sesión.",
        }).then(() => {
          setcuAbierta(false);
          setcuValida(null);
        });
      }
    }
  }, [cuValida]);

  const ambiente_productivo = ambiente_produccion;
  const handleClick = () => {
    //setCargandoDatos(true);
    //verificar ambiente JARYS INVALIDAR CU
    if (!ambiente_produccion) {
        setcuValida(true);
        return;
    }

    setcuAbierta(true);

    const rut = user.user.run;
    window.location.href = `/claveUnica/${rut}/${id_precalifiacion}/${acuerdo}`;

    /*const dataCu = window.open("/claveUnica/" + rut+"/"+id_precalifiacion);
    var timer = setInterval(function () {
      console.log("DATA CU",dataCu.location)
      if (dataCu.closed) {
        //clearInterval(timer);
        console.log("se ha cerrado la ventana");
        console.log(dataCu);
        setcuAbierta(false);
      } else {
        try {
          if (dataCu.location.pathname === "/successCu") {
            console.log('se intentó arrancar');

            const pair = dataCu.location.search.replace("?", "").split("=");
            console.log(pair);
            const rut_enviado = pair[1].split("&")[0];
            let rut_recibido = pair[2].split("&")[0];
            if (rut_recibido.length < rut_enviado.length) {
              rut_recibido = "0" + rut_recibido;
            }
            console.log("Nueva-----");
            if (pair[3] === "true") {
              setcuValida(true);
            } else if (rut_enviado === rut_recibido) {
              setcuValida(true);
            } else {
              setcuValida(false);
            }

            clearInterval(timer);
            dataCu.close();
          }
        } catch (error) {
          console.log('se perdió conexión con la ventan');
        }
      }
    }, 200);*/
  };

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          >
            <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
               Validar Evaluación/Precalificación
            </h1>
            <span className="h-20px border-gray-300 border-start mx-4" />
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li className="breadcrumb-item text-muted">
                <a href="#" className="text-muted text-hover-primary">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark">
                Buscar Proceso de Calificación
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <InformacionFuncionario
              id_participant={id_participant}
              boton_historial={false}
            ></InformacionFuncionario>
            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-body">
                  {!cuAbierta ? (
                    <div className="row">
                      <div className="col-lg-8 col-sm-12">
                        <FormularioCalificacion
                          calificacion={id_precalifiacion}
                        ></FormularioCalificacion>
                      </div>
                      <div className="col-lg-4 col-sm-12">
                        <div>
                          <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-12 p-6">
                            <span className="svg-icon svg-icon-2tx svg-icon-warning me-4">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.3"
                                  x={2}
                                  y={2}
                                  width={20}
                                  height={20}
                                  rx={10}
                                  fill="currentColor"
                                />
                                <rect
                                  x={11}
                                  y={14}
                                  width={7}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-90 11 14)"
                                  fill="currentColor"
                                />
                                <rect
                                  x={11}
                                  y={17}
                                  width={2}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-90 11 17)"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            <div className="d-flex flex-stack flex-grow-1">
                              <div className="fw-bold">
                                <h4 className="text-gray-900 fw-bolder">
                                  ¡Importante!
                                </h4>
                                <div className="fs-6 text-gray-700">
                                  Ratifico que mi evaluador se reunió conmigo
                                  para entregar retroalimentación y
                                  fundamentación de mi Evaluación.
                                </div>
                                <div className="form-check form-check-custom  form-check-success form-check-solid mt-8">

                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="acepto"
                                      id="acepto_si"
                                      value="si"
                                      checked={acepto === true}
                                      onChange={() => setAcepto(true)}
                                    />
                                    <label className="form-check-label" htmlFor="acepto_si">
                                      Sí
                                    </label>
                                  </div>

                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="acepto"
                                      id="acepto_no"
                                      value="no"
                                      checked={acepto === false}
                                      onChange={() => setAcepto(false)}
                                    />
                                    <label className="form-check-label" htmlFor="acepto_no">
                                      No
                                    </label>
                                  </div>

                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="notice d-flex bg-light-info rounded border-info border border-dashed mb-12 p-6">
                            <span className="svg-icon svg-icon-2tx svg-icon-info me-4">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.3"
                                  x={2}
                                  y={2}
                                  width={20}
                                  height={20}
                                  rx={10}
                                  fill="currentColor"
                                />
                                <rect
                                  x={11}
                                  y={14}
                                  width={7}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-90 11 14)"
                                  fill="currentColor"
                                />
                                <rect
                                  x={11}
                                  y={17}
                                  width={2}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-90 11 17)"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            <div className="d-flex flex-stack flex-grow-1">
                              {!cuAbierta ? (
                                <div className="fw-bold">
                                  <h4 className="text-gray-900 fw-bolder mb-10">
                                    ¿Estoy de acuerdo con mi Evaluación?
                                  </h4>
                                  <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      defaultValue=""
                                      name="validar"
                                      id="flexRadioChecked"
                                      checked={acuerdo && acuerdo != null}
                                      onClick={() => setAcuerdo(true)}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexRadioChecked"
                                    >
                                      De acuerdo
                                    </label>
                                  </div>
                                  <div className="form-check form-check-custom form-check-danger form-check-solid">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      defaultValue=""
                                      name="validar"
                                      id="flexRadioChecked2"
                                      checked={!acuerdo && acuerdo != null}
                                      onClick={() => setAcuerdo(false)}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexRadioChecked2"
                                    >
                                      Desacuerdo
                                    </label>
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-info px-6 mt-8 align-self-center text-nowrap"
                                    onClick={() => handleClick()}
                                    disabled={
                                      cargandoDatos ||
                                      acuerdo == null 
                                    }
                                  >
                                    {cargandoDatos
                                      ? "Validando..."
                                      : "Validar con Clave Única"}
                                  </button>
                                </div>
                              ) : (
                                <div class="alert alert-primary" role="alert">
                                  <b>
                                    Esperando autenticación con clave única, no
                                    cierre esta pantalla hasta que vea el
                                    mensaje de éxito...
                                    {!ambiente_productivo &&
                                      `AMBIENTE DE DESARROLLO ESPERE...`}
                                  </b>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-12 text-center mt-4 p-5">
                        <Dimmer active inverted className="mt-5 mb-5">
                          <Loader
                            size="big"
                            inverted
                            content="Validando autenticación con Clave Única, espere un momento"
                          />
                        </Dimmer>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
